import { scoreValidation } from '@/utils/utils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'dependent-competencies',
})

export default class DependentCompetencies extends Vue {

    // ---------------------------------------------------------
    // Properties

    @Prop()
    private dependentCompetencies: any;

    @Prop()
    private primaryCompetency: any;

    @Prop()
    private showcaseCompetency: any;

    private competenciesList: any = [];

    private isShowMore: boolean = false;

    private searchTerms: string = '';

    @Watch('showcaseCompetency')
    private watchCompetency() {
        const dependentComp = this.showcaseCompetency;
        const competency = this.primaryCompetency;
        const hasPrimaryCompetency = this.competenciesList.find(
            (item: any) => item.competencyCode === competency.competencyCode);
        if (dependentComp.competencyCode !== competency.competencyCode && !hasPrimaryCompetency) {
            this.competenciesList.unshift(this.primaryCompetency);
        }
        if (dependentComp.competencyCode === competency.competencyCode) {
            this.competenciesList = this.competenciesList.filter(
                (item: any) => item.competencyCode !== competency.competencyCode);
        }
    }



    // ----------------------------------------------------------
    // Hooks

    private created() {
        this.competenciesList = this.dependentCompetencies.slice(0, 5);
        if (this.dependentCompetencies.length > 5) {
            this.isShowMore = true;
        }
    }

    // ----------------------------------------------------------
    // Actions

    private onShowMore() {
        this.competenciesList = this.dependentCompetencies;
        this.isShowMore = false;
    }

    private onEditDependent(dependent: any) {
        this.$emit('onEditDependent', dependent);
    }

    private onChangeConfidence(event: any) {
        scoreValidation(event, 1);
    }

    // ----------------------------------------------------------
    // Methods

    private filterCompetencies(arrayItem: any) {
        return arrayItem ? arrayItem.filter(
            (item: any) =>
            ((item.competencyName.toLowerCase()).startsWith(this.searchTerms.toLowerCase()) ||
            (item.competencyDisplayCode.toLowerCase()).startsWith(this.searchTerms.toLowerCase()))) : [];
    }

}
